// 生态圈 分析进度 接口
class NodeAnalysisApi {
    /**
     * 获取分页表格数据
     * @param data 查询参数
     * @returns
     */
    getInfo(_this,data) {
      return _this.$http({
        url: '/base/ecosphere/ecosphereAnalysisList',
        method: 'POST',
        data,
      })
    }
   
    /**
     * 导出接口
     * @param data 导出参数
     * @returns
     */
    getExcel(_this,data,name) {
      return _this.httpFile({
        url: '/base/ecosphere/sqmExportEcosphereAnalysisList',
        method: 'POST',
        data,
      },name)
    }

    /**
     * 详情接口
     * @param data 详情参数
     * @returns
     */
    getDetail(_this,data) {
      return _this.$http({
        url: '/base/ecosphere/ecosphereAnalysisChaList',
        method: 'POST',
        data,
      })
    }

    /**
     * 分析历史
     * @param data 详情参数
     * @returns
     */
    getAnalyseHistory(_this,data){
      return _this.$http({
        url: '/base/emr/getAnalysisHistory',
        method: 'POST',
        params: {
          ...data
        }
      })
    }

     /**
     * 操作日志
     * @param data 详情参数
     * @returns
     */
    getOperationLog(_this,data){
      return _this.$http({
        url: '/base/emr/getAnalysisOperateHistory',
        method: 'POST',
        params: {
          ...data
        }
      })
    }

    /**
     * sqe节点列表
     * @param data 参数
     * @returns
     */
    getSqeNodeList(_this,data){
      return _this.$http({
        url: '/base/ecosphere/sqeEcosphereList',
        method: 'POST',
        data: {
          pageNo:1,
          pageSize:99999,
          createTime: undefined,
          updateTime: undefined,
          ...data,
        }
      })
    }

    /**
     * 生态圈
     * @param data 参数
     * @returns
     */

    getEcoList(_this,data){
      return _this.$http({
        url: '/base/ecosphere/ecosphereList',
        method: 'POST',
        data: {
          pageNo:1,
          pageSize:99999,
          createTime: undefined,
          updateTime: undefined,
          ...data,
        }
      })
    }

    /**
     * 供应商模糊查询
     * @param data 参数
     * @returns
     */
    apiSupplyCodeChange(_this,data,cancelToken){
      return _this.$http({
        url: '/base/basicData/searchSupplierList',
        method: 'POST',
        data: {
          ...data,
        },
        cancelToken:cancelToken
      })
    }

    /**
     * 专用号模糊查询
     * @param data 参数
     * @returns
     */
    apiMtlNoChange(_this,data,cancelToken){
      return _this.$http({
        url: '/base/basicData/searchMaterielList',
        method: 'POST',
        data: {
          ...data,
        },
        cancelToken:cancelToken
      })
    }
    
  }
   
  const nodeAnalysisApi = new NodeAnalysisApi()
   
  export default nodeAnalysisApi